module.exports = __webpack_public_path__ + "assets/img/3204.a397ebf0.png";